import { createFileRoute } from "@tanstack/react-router";
import { SignupPage } from "@project/user/pages/auth/SignupPage";

export const Route = createFileRoute("/_user/signup")({
  head: () => ({
    meta: [
      { title: "Create Account — Jivandhara" },
      {
        name: "description",
        content: "Create your Jivandhara account using phone OTP.",
      },
    ],
  }),
  component: SignupPage,
});
